"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _text = require("@mmc/text");

var _specifications = _interopRequireDefault(require("../styles/specifications.css"));

var Specifications = function Specifications(_ref) {
  var theme = _ref.theme,
      label = _ref.label,
      image = _ref.image,
      disclaimerData = _ref.disclaimerData;

  if (!label || label === ' ') {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _specifications["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _specifications["default"].image,
    src: image,
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: label,
    className: _specifications["default"].label + " " + theme.tags,
    disclaimerData: disclaimerData
  }));
};

Specifications.displayName = 'Specifications';
var _default = Specifications;
exports["default"] = _default;